const PrivacyPolicy = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/DocCenter/PrivacyPolicy.vue')
const UserProtocol = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/DocCenter/UserProtocol.vue')

const routes = [
  // echo
  {
    path: '/docs/iOS/privacy-protocol',
    name: 'echo',
    component: PrivacyPolicy
  },
  {
    path: '/docs/iOS/user-protocol',
    name: 'echo',
    component: UserProtocol
  },
  // joychat
  {
    path: '/joychat-privacy',
    name: 'joychat',
    component: PrivacyPolicy
  },
  {
    path: '/joychat-user',
    name: 'joychat',
    component: UserProtocol
  },
  // kiko
  {
    path: '/docs/kiko/privacy-protocol',
    name: 'kiko',
    component: PrivacyPolicy
  },
  {
    path: '/docs/kiko/user-protocol',
    name: 'kiko',
    component: UserProtocol
  },
  // vava
  {
    path: '/privacy-agreement',
    name: 'vava',
    component: PrivacyPolicy
  },
  {
    path: '/user-agreement',
    name: 'vava',
    component: UserProtocol
  },
  // vibeo
  {
    path: '/docs/vibeo/privacy-protocol',
    name: 'vibeo',
    component: PrivacyPolicy
  },
  {
    path: '/docs/vibeo/user-protocol',
    name: 'vibeo',
    component: UserProtocol
  }
]
export default routes
